export default "__VITE_ASSET__DL29cZu9__"